import { RE_INITIALIZE_ORDER_FILTER, SET_ORDER_FILTER } from '../../actionTypes/orderfilter'

export const reInitializeOrderFilter = () => ({ type: RE_INITIALIZE_ORDER_FILTER })

export const setOrderFilter = value => ({ type: SET_ORDER_FILTER, value })
